/**
 * ==========================================================
 * QUICK VARIANT BADGES
 * FABRIC
 *
 * CARDS:
 * - ÚLTIMAS UNIDADES
 * - BEST SELLER
 * - REPOSIÇÃO
 * - NOVIDADE
 * - DESCONTO
 * - SOU DE ALGODÃO VERTICAL
 *
 * PDP:
 * - SOU DE ALGODÃO HORIZONTAL
 * ==========================================================
 */


/* ==========================================================
   CARDS
========================================================== */

function applyBadges() {

    document.querySelectorAll("product-card").forEach(card => {

        const gallery =
            card.querySelector('[data-badges-ready]') ||
            card.querySelector('.card-gallery') ||
            card.querySelector('.custom-product-card-media');

        if (!gallery) return;


        const quickVariant =
            card.querySelector('.quick-variant') ||
            card.querySelector('.quick-variant-fallback');


        /* ==================================================
           QUICK VARIANT AINDA NÃO CARREGOU
        ================================================== */

        if (!quickVariant) {

            if (card.dataset.badgesWaiting) {
                return;
            }

            card.dataset.badgesWaiting = 'true';

            setTimeout(() => {

                delete card.dataset.badgesWaiting;

                applyBadges();

            }, 300);

            return;
        }


        /* ==================================================
           DADOS DO PRODUTO
        ================================================== */

        const collections =
            (quickVariant.dataset.collections || '')
                .toLowerCase()
                .split(',')
                .map(item => item.trim())
                .filter(Boolean);


        const price =
            Number(
                quickVariant.dataset.price
            ) || 0;


        const compare =
            Number(
                quickVariant.dataset.comparePrice
            ) || 0;


        const stock =
            Number(
                quickVariant.dataset.stock
            ) || 0;


        const algodaoSrc =
            quickVariant.dataset.tagAlgodaoSrc || '';


        const isSouDeAlgodao =
            collections.includes(
                'sou-de-algodao'
            );


        /* ==================================================
           SOU DE ALGODÃO
           CARD / VERTICAL
        ================================================== */

        let algodaoBadge =
            gallery.querySelector(
                '.algodao-banner--card'
            );


        /*
         * Produto pertence à coleção
         */

        if (
            isSouDeAlgodao &&
            algodaoSrc
        ) {

            if (!algodaoBadge) {

                algodaoBadge =
                    document.createElement(
                        'div'
                    );


                algodaoBadge.className =
                    'algodao-banner algodao-banner--card';


                const algodaoImage =
                    document.createElement(
                        'img'
                    );


                algodaoImage.className =
                    'algodao-banner__image algodao-banner__image--card';


                algodaoImage.src =
                    algodaoSrc;


                algodaoImage.alt =
                    'Sou de Algodão';


                algodaoImage.loading =
                    'lazy';


                algodaoImage.decoding =
                    'async';


                algodaoBadge.appendChild(
                    algodaoImage
                );


                /*
                 * Insere diretamente
                 * na mídia do produto
                 */

                gallery.appendChild(
                    algodaoBadge
                );

            }

        }

        /*
         * Não pertence à coleção
         */

        else {

            if (algodaoBadge) {

                algodaoBadge.remove();

            }

        }


        /* ==================================================
           ESTADO DO CARD
        ================================================== */

        const state =

            `${quickVariant.dataset.collections || ''}|` +

            `${quickVariant.dataset.price || ''}|` +

            `${quickVariant.dataset.comparePrice || ''}|` +

            `${quickVariant.dataset.stock || ''}|` +

            `${isSouDeAlgodao}|` +

            `${algodaoSrc}`;


        /*
         * Importante:
         * o algodão foi tratado ANTES deste return.
         */

        if (
            card.dataset.badgesState === state
        ) {
            return;
        }


        card.dataset.badgesState =
            state;


        /* ==================================================
           BADGES TRADICIONAIS
        ================================================== */

        const lowStock =
            stock > 0 &&
            stock <= 3;


        const badges = [];


        if (lowStock) {

            badges.push(
                'ÚLTIMAS UNIDADES'
            );

        }


        if (
            collections.includes(
                'best-sellers'
            )
        ) {

            badges.push(
                'BEST SELLER'
            );

        }


        if (
            collections.includes(
                'reposicao'
            )
        ) {

            badges.push(
                'REPOSIÇÃO'
            );

        }


        if (
            collections.includes(
                'novidades'
            )
        ) {

            badges.push(
                'NOVIDADE'
            );

        }


        /* ==================================================
           DESCONTO
        ================================================== */

        if (
            compare > price &&
            compare > 0
        ) {

            const percent =
                Math.round(
                    (
                        (compare - price) /
                        compare
                    ) * 100
                );


            badges.push(
                `${percent}% OFF`
            );

        }


        /* ==================================================
           WRAPPER DAS TAGS TRADICIONAIS
        ================================================== */

        let wrapper =
            gallery.querySelector(
                '.product-badges'
            );


        if (!wrapper) {

            wrapper =
                document.createElement(
                    'div'
                );


            wrapper.className =
                'product-badges product-badges--top-left';


            gallery.prepend(
                wrapper
            );

        }


        /* ==================================================
           ESGOTADO
        ================================================== */

        const hasSoldOut =
            [
                ...wrapper.querySelectorAll(
                    '.product-badges__badge'
                )
            ]
                .some(badge =>

                    badge.textContent
                        .trim()
                        .toLowerCase()
                        .includes(
                            'esgotado'
                        )

                );


        /*
         * O Sou de Algodão continua
         * aparecendo mesmo se esgotado.
         */

        if (hasSoldOut) {
            return;
        }


        /* ==================================================
           REMOVE BADGES CUSTOMIZADOS ANTERIORES
        ================================================== */

        wrapper
            .querySelectorAll(
                '.na-custom-badge'
            )
            .forEach(
                el => el.remove()
            );


        /* ==================================================
           REMOVE PROMOÇÃO NATIVA
        ================================================== */

        wrapper
            .querySelectorAll(
                '.product-badges__badge'
            )
            .forEach(el => {

                const text =
                    el.textContent
                        .trim()
                        .toLowerCase();


                if (
                    text.includes(
                        'promoção'
                    ) ||

                    text.includes(
                        'promotion'
                    ) ||

                    text.includes(
                        'sale'
                    )
                ) {

                    el.remove();

                }

            });


        /* ==================================================
           CRIA BADGES
        ================================================== */

        badges.forEach(text => {

            const badge =
                document.createElement(
                    'div'
                );


            badge.className =
                'product-badges__badge product-badges__badge--rectangle na-custom-badge';


            badge.textContent =
                text;


            wrapper.appendChild(
                badge
            );

        });

    });

}


/* ==========================================================
   DISPONIBILIZA PARA O LOADER
========================================================== */

window.applyBadges =
    applyBadges;


/* ==========================================================
   OBSERVER DOS CARDS
========================================================== */

let cardRaf = null;


const cardsObserver =
    new MutationObserver(
        mutations => {

            let shouldRun =
                false;


            for (
                const mutation
                of mutations
            ) {

                for (
                    const node
                    of mutation.addedNodes
                ) {

                    if (
                        !(node instanceof HTMLElement)
                    ) {
                        continue;
                    }


                    /*
                     * Ignora alterações
                     * feitas pelo próprio script
                     */

                    if (

                        node.classList?.contains(
                            'na-custom-badge'
                        ) ||

                        node.classList?.contains(
                            'algodao-banner'
                        ) ||

                        node.classList?.contains(
                            'algodao-banner__image'
                        )

                    ) {

                        continue;

                    }


                    if (

                        node.matches?.(
                            'product-card'
                        ) ||

                        node.querySelector?.(
                            'product-card'
                        ) ||

                        node.matches?.(
                            '.quick-variant'
                        ) ||

                        node.matches?.(
                            '.quick-variant-fallback'
                        ) ||

                        node.querySelector?.(
                            '.quick-variant'
                        ) ||

                        node.querySelector?.(
                            '.quick-variant-fallback'
                        )

                    ) {

                        shouldRun =
                            true;

                        break;

                    }

                }


                if (shouldRun) {
                    break;
                }

            }


            if (
                !shouldRun ||
                cardRaf
            ) {

                return;

            }


            cardRaf =
                requestAnimationFrame(
                    () => {

                        cardRaf =
                            null;

                        applyBadges();

                    }
                );

        }
    );


cardsObserver.observe(
    document.body,
    {
        childList: true,
        subtree: true
    }
);


/* ==========================================================
   SHOPIFY / FILTROS
========================================================== */

document.addEventListener(
    'shopify:section:load',
    () => {

        requestAnimationFrame(
            applyBadges
        );

    }
);


document.addEventListener(
    'shopify:section:reorder',
    () => {

        requestAnimationFrame(
            applyBadges
        );

    }
);


/* ==========================================================
   EXECUÇÃO INICIAL DOS CARDS
========================================================== */

if (
    document.readyState ===
    'loading'
) {

    document.addEventListener(
        'DOMContentLoaded',
        applyBadges,
        { once: true }
    );

} else {

    applyBadges();

}


/* ==========================================================
   PDP - SOU DE ALGODÃO HORIZONTAL
========================================================== */

function applyProductPageAlgodaoBadge() {

    const containers =
        document.querySelectorAll(
            '.product-page-badges'
        );


    containers.forEach(
        container => {

            /*
             * O Liquid informa true/false.
             */

            const isSouDeAlgodao =

                String(
                    container.dataset
                        .souDeAlgodao || ''
                )
                    .trim()
                    .toLowerCase()

                === 'true';


            /*
             * URL do selo horizontal.
             */

            const imageSrc =
                container.dataset
                    .tagAlgodaoHorizontalSrc || '';


            /*
             * Procura selo já criado.
             */

            let badge =
                container.querySelector(
                    '.algodao-banner-horizontal'
                );


            /* ==========================================
               NÃO É SOU DE ALGODÃO
            ========================================== */

            if (!isSouDeAlgodao) {

                if (badge) {

                    badge.remove();

                }

                return;

            }


            /* ==========================================
               SEM URL
            ========================================== */

            if (!imageSrc) {

                console.warn(
                    '[Sou de Algodão PDP] tagalgodao-horizontal.png não encontrada.'
                );

                return;

            }


            /* ==========================================
               JÁ EXISTE
            ========================================== */

            if (badge) {

                /*
                 * Sempre primeiro.
                 */

                if (
                    container.firstElementChild
                    !== badge
                ) {

                    container.prepend(
                        badge
                    );

                }

                return;

            }


            /* ==========================================
               CRIA SELO HORIZONTAL
            ========================================== */

            badge =
                document.createElement(
                    'div'
                );


            badge.className =
                'algodao-banner-horizontal';


            const image =
                document.createElement(
                    'img'
                );


            image.className =
                'algodao-banner-horizontal__image';


            image.src =
                imageSrc;


            image.alt =
                'Sou de Algodão';


            image.loading =
                'eager';


            image.decoding =
                'async';


            badge.appendChild(
                image
            );


            /*
             * SEMPRE ANTES DE:
             *
             * ESGOTADO
             * ÚLTIMAS UNIDADES
             * BEST SELLER
             * NOVIDADE
             * REPOSIÇÃO
             */

            container.prepend(
                badge
            );

        }
    );

}


/* ==========================================================
   DISPONIBILIZA PDP GLOBALMENTE
========================================================== */

window.applyProductPageAlgodaoBadge =
    applyProductPageAlgodaoBadge;


/* ==========================================================
   EXECUÇÃO INICIAL PDP
========================================================== */

if (
    document.readyState ===
    'loading'
) {

    document.addEventListener(
        'DOMContentLoaded',
        applyProductPageAlgodaoBadge,
        { once: true }
    );

} else {

    applyProductPageAlgodaoBadge();

}


window.addEventListener(
    'load',
    applyProductPageAlgodaoBadge
);


/* ==========================================================
   ALTERAÇÃO DE VARIANTE
========================================================== */

document.addEventListener(
    'variant:change',
    () => {

        requestAnimationFrame(
            applyProductPageAlgodaoBadge
        );

    }
);


/* ==========================================================
   SEÇÃO SHOPIFY
========================================================== */

document.addEventListener(
    'shopify:section:load',
    () => {

        requestAnimationFrame(
            applyProductPageAlgodaoBadge
        );

    }
);


/* ==========================================================
   OBSERVER PDP
========================================================== */

let pdpRaf = null;


const pdpObserver =
    new MutationObserver(
        mutations => {

            let shouldRun =
                false;


            for (
                const mutation
                of mutations
            ) {

                for (
                    const node
                    of mutation.addedNodes
                ) {

                    if (
                        !(node instanceof HTMLElement)
                    ) {
                        continue;
                    }


                    /*
                     * Ignora o próprio
                     * selo horizontal.
                     */

                    if (

                        node.classList?.contains(
                            'algodao-banner-horizontal'
                        ) ||

                        node.classList?.contains(
                            'algodao-banner-horizontal__image'
                        )

                    ) {

                        continue;

                    }


                    if (

                        node.matches?.(
                            '.product-page-badges'
                        ) ||

                        node.querySelector?.(
                            '.product-page-badges'
                        )

                    ) {

                        shouldRun =
                            true;

                        break;

                    }

                }


                if (shouldRun) {
                    break;
                }

            }


            if (
                !shouldRun ||
                pdpRaf
            ) {

                return;

            }


            pdpRaf =
                requestAnimationFrame(
                    () => {

                        pdpRaf =
                            null;

                        applyProductPageAlgodaoBadge();

                    }
                );

        }
    );


pdpObserver.observe(
    document.body,
    {
        childList: true,
        subtree: true
    }
);